export const getVariantDimensions = (variant) => {
  let dimensions = variant.dimensions;
  let p = variant.product;

  //Get our option index for dimensions
  let optionIndex;
  p.options.filter((option, i) => {
    let on = option.toLowerCase();
    if(on.indexOf('dimensions') !== -1) optionIndex = `option${(i + 1)}`;
  });

  //If it exists, trump the metafield for dimensions
  if(variant[optionIndex]) dimensions = variant[optionIndex];
  return dimensions;
}